import { useState, useEffect } from "react";
import { ethers } from "ethers";
import { Link } from "react-router-dom";
import { ADDRESSES, ABIS } from "../utils/contracts";

export default function FakeBayc() {
  const [name, setName] = useState("");
  const [totalSupply, setTotalSupply] = useState(0);
  const [loading, setLoading] = useState(false);

  // 1. Fetch Contract Data (Read)
  useEffect(() => {
    const fetchData = async () => {
      if (!window.ethereum) return;
      const provider = new ethers.BrowserProvider(window.ethereum);
      const contract = new ethers.Contract(ADDRESSES.BAYC, ABIS.BAYC, provider);
      
      try {
        const _name = await contract.name();
        const _total = await contract.totalSupply();
        setName(_name);
        setTotalSupply(_total.toString());
      } catch (err) {
        console.error("Error fetching BAYC data:", err);
      }
    };
    fetchData();
  }, []);

  // 2. Claim Token (Write)
  const claimToken = async () => {
    if (!window.ethereum) return alert("Install MetaMask");
    setLoading(true);
    try {
      const provider = new ethers.BrowserProvider(window.ethereum);
      const signer = await provider.getSigner();
      const contract = new ethers.Contract(ADDRESSES.BAYC, ABIS.BAYC, signer);

      const tx = await contract.claimAToken();
      await tx.wait();
      alert("Token Claimed Successfully!");
      window.location.reload(); // Refresh to update total supply
    } catch (err) {
      console.error(err);
      alert("Claim failed. Check console.");
    }
    setLoading(false);
  };

  return (
    <div>
      <h1>{name || "Loading..."}</h1>
      <p>Total Supply: {totalSupply}</p>
      
      <button onClick={claimToken} disabled={loading}>
        {loading ? "Claiming..." : "Claim a Token"}
      </button>

      <hr />
      <h3>View Token Details</h3>
      <p>Enter a Token ID to view metadata:</p>
      <input type="number" id="tokenIdInput" placeholder="e.g. 1" />
      <button onClick={() => {
        const id = document.getElementById("tokenIdInput").value;
        if(id) window.location.href = `/fakeBayc/${id}`;
      }}>Go</button>
    </div>
  );
}